<template>

  <!-- 最新年度の実績 -->
  <div>
    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.disabilitiesRate.achievementDisabilitiesRate.$invalid 
      || $v.disabilitiesRate.disabledDisabilities.$invalid
      || $v.disabilitiesRate.intellectualDisabilities.$invalid
      || $v.disabilitiesRate.mentallyDisabilities.$invalid
      || $v.disabilitiesRate.resultMemo.$invalid 
      || $v.disabilitiesRate.actionMemo.$invalid">
      <div v-if="$v.disabilitiesRate.achievementDisabilitiesRate.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績　障がい者雇用率</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.achievementDisabilitiesRate.$invalid && !$v.disabilitiesRate.achievementDisabilitiesRate.customDoubleNum" validation="customDoubleNum" valueInt="2" valueDouble="1"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.achievementDisabilitiesRate.$invalid && $v.disabilitiesRate.achievementDisabilitiesRate.numeric && !$v.disabilitiesRate.achievementDisabilitiesRate.between" validation="between" valueMin="0" valueMax="100"/>
      </div>
      <div v-if="$v.disabilitiesRate.disabledDisabilities.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">障がい者雇用数（身体）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.disabledDisabilities.$invalid && !$v.disabilitiesRate.disabledDisabilities.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.disabledDisabilities.$invalid && $v.disabilitiesRate.disabledDisabilities.numeric && !$v.disabilitiesRate.disabledDisabilities.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.disabilitiesRate.intellectualDisabilities.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">障がい者雇用数（知的）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.intellectualDisabilities.$invalid && !$v.disabilitiesRate.intellectualDisabilities.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.intellectualDisabilities.$invalid && $v.disabilitiesRate.intellectualDisabilities.numeric && !$v.disabilitiesRate.intellectualDisabilities.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.disabilitiesRate.mentallyDisabilities.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">障がい者雇用数（精神）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.mentallyDisabilities.$invalid && !$v.disabilitiesRate.mentallyDisabilities.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.disabilitiesRate.mentallyDisabilities.$invalid && $v.disabilitiesRate.mentallyDisabilities.numeric && !$v.disabilitiesRate.mentallyDisabilities.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.disabilitiesRate.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.disabilitiesRate.resultMemo.$invalid && !$v.disabilitiesRate.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.disabilitiesRate.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.disabilitiesRate.actionMemo.$invalid && !$v.disabilitiesRate.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">障がい者雇用数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 50%;">
            <col>
          </colgroup>
          <tbody>
            <tr>
              <th>身体</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.disabilitiesRate.$model.disabledDisabilities" type="text" name="disabilitiesRate.disabledDisabilities" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>知的</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.disabilitiesRate.$model.intellectualDisabilities" type="text" name="disabilitiesRate.intellectualDisabilities" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
            <tr>
              <th>精神</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.disabilitiesRate.$model.mentallyDisabilities" type="text" name="disabilitiesRate.mentallyDisabilities" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__space"></div>

      <div class="human-capitalt-data-wrap__results">
        <div class="human-capitalt-data-results">
          <div class="human-capitalt-data-results__text">
            障がい者雇用率
            <div class="human-capitalt-data-table__input is-important has-unit">
              <TextBox v-model.trim="$v.disabilitiesRate.$model.achievementDisabilitiesRate" type="text" name="disabilitiesRate.achievementDisabilitiesRate" class="u-tac" @input="changeInput()"></TextBox>
              <span class="human-capitalt-data-table__unit">%</span>
            </div>
          </div>
        </div>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="disabilitiesRate.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(disabilitiesRate.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="disabilitiesRate.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
  },
  props: {
    // 表示年度の障がい者雇用率保存データ
    disabilitiesRate: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
  },
  validations: {
    disabilitiesRate: {
      achievementDisabilitiesRate: { // 管理職障がい者雇用率
        between: between(0,100),
        customDoubleNum: (value) => {
          if ( value != null && value.length == 0 ) return true;
          if ( value != null ) return /^([1-9][0-9]{0,3}|0)(\.[0-9]{1,1})?$/.test(value);
          return true;
        }
      },
      disabledDisabilities : { numeric, between: between(0,99999) },       // 障がい者雇用数（身体）
      intellectualDisabilities : { numeric, between: between(0,99999) },   // 障がい者雇用数（知的）
      mentallyDisabilities : { numeric, between: between(0,99999) },       // 障がい者雇用数（精神）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    disabilitiesRate() {
      this.inputDisabilitiesRate();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputDisabilitiesRate() {
      this.$emit("change-disabilities-rate", {
        disabilitiesRate: this.disabilitiesRate,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
